import { env } from "@/lib/env"
import { resolveApiUrl } from "@/lib/api-url"
import { authHeaders, getAuthHeaders } from "@/services/api.client"
import type { EngagementPayload } from "./engagement"

export const ENGAGEMENT_PATH = "/api/v1/telemetry/answer-engagement"

/**
 * POST one reading-behaviour flush. fetch with keepalive (not sendBeacon, which cannot carry the
 * Authorization header), so it survives a page close. `sync` uses the token the API client last held,
 * for pagehide / hidden where nothing can be awaited. Fire and forget: never throws, drops silently.
 */
export async function sendEngagement(payload: EngagementPayload, sync = false): Promise<void> {
  try {
    const headers = sync ? authHeaders() : await getAuthHeaders()
    if (!headers.Authorization) return // signed out, or no token yet: nothing to attach
    void fetch(resolveApiUrl(env.VITE_API_URL, ENGAGEMENT_PATH), {
      method: "POST",
      headers: { ...headers, "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
      credentials: "include",
    }).catch(() => undefined)
  } catch {
    /* telemetry must never reach the UI */
  }
}

/** Warm the token cache so a pagehide flush has a token to attach. */
export function primeEngagementAuth(): void {
  void getAuthHeaders().catch(() => undefined)
}
